import type { FiltersState } from "@/components/data-table-filter/core/types";
import { z } from "zod";

const rawFilterModelSchema = z.object({
  columnId: z.string(),
  type: z.string(),
  operator: z.string(),
  values: z.array(z.unknown()),
});

export const searchStringSearchSchema = z.object({
  searchString: z.string().optional(),
});

function isFiltersState(value: unknown): value is FiltersState {
  return z.array(rawFilterModelSchema).safeParse(value).success;
}

export const filtersStateSchema = z.custom<FiltersState>(isFiltersState);

export const dataTableFiltersSearchSchema = z.object({
  filters: filtersStateSchema.optional(),
  searchString: z.string().optional(),
});

export const myClassesSearchSchema = z.object({
  tab: z.string().catch("teaching"),
  searchString: z.string().optional(),
});

export const optionalSemesterSearchSchema = z.object({
  semesterId: z.coerce.number().optional(),
});
